import { awaitRequests, promise } from '../../../helpers';
import { firebaseDelete } from '../firebase';
import { afterDeleteBook } from './index';

const deleteBook = (docId, where) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // after delete
        const afterDelete = item => {
            const reqs = [];

            if (item && item.id) {
                // --
                reqs.push(dispatch(afterDeleteBook({ docId: item.id, item })));
            }

            return awaitRequests(reqs).then(() => promise(item));
        };

        // -- delete by docId
        if (docId) {
            return dispatch(firebaseDelete({ collection: 'books', docId })).then(item => afterDelete(item));
        }

        // -- delete where
        if (where) {
            return dispatch(firebaseDelete({ collection: 'books', where })).then(deletedItems =>
                awaitRequests(deletedItems.map(item => afterDelete(item))),
            );
        }

        return promise();
    };
};

export default deleteBook;
